export function bytesToMB(bytes) {
  const MB = bytes / (1024 * 1024);
  return MB.toFixed(2);
}
